import { useEffect } from "react";

/**
 * Lightweight per-page SEO helper.
 * Sets <title>, <meta name="description">, and OG/Twitter equivalents.
 * Restores previous values on unmount so the app-default meta stays consistent.
 */
export default function usePageMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    const setMeta = (selector, attr, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = selector.replace("meta[", "").replace("]", "").split("=");
        el.setAttribute(k, v.replace(/["']/g, ""));
        document.head.appendChild(el);
      }
      const prev = el.getAttribute(attr);
      el.setAttribute(attr, value);
      return () => { if (prev !== null) el.setAttribute(attr, prev); };
    };

    if (title) document.title = title;
    const restores = [];
    if (description) {
      restores.push(setMeta('meta[name="description"]', "content", description));
      restores.push(setMeta('meta[property="og:description"]', "content", description));
      restores.push(setMeta('meta[name="twitter:description"]', "content", description));
    }
    if (title) {
      restores.push(setMeta('meta[property="og:title"]', "content", title));
      restores.push(setMeta('meta[name="twitter:title"]', "content", title));
    }

    return () => {
      document.title = prevTitle;
      restores.forEach((fn) => fn && fn());
    };
  }, [title, description]);
}
